import oRequest from '@/libsV2/request.js';
const URL = {
    GET_USER: "/user/index/index", //用户信息 post5
    APPLY_PAD:'/shop/Xcxlogin/userpassapply'
};

export const getUser = (data = {}) => {
    return oRequest.getData(URL.GET_USER, data);
};
export const applyPad = (data = {}) => {
    return oRequest.getData(URL.APPLY_PAD, data);
};
